// css =>
import "../../BaseStructure.css";

// componenets =>
import Header from "../../Components/header/header.comp";
import HeaderTittle from "../../Components/headerTittle/headerTittle.comp";
import LocationShow from "../../Components/locationShow/locationShow.comp";
import OrderHistoryBox from "../../Components/orderHistoryBox/orderHistoryBox.comp";

// pic =>
import NotImage from "../../Assets/Pictures/No_Image.png";

// react =>
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// type =>
import { ORDER_HISTORY_RESPONSE, ORDER_HISTORY_ITEM } from "../OrderHistory/OrderHistoryType";

// API =>
import backEnd from "../../services/Api";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

// hooks =>
import { useUserStore } from "../../hooks/useUserStore";

// utils =>
import { formatPrice } from "../../utils/ChangePriceFormat";

function ShowOrderDetails() {

    const location = useLocation();
    const { showMessage } = useMessage();
    const { orderId } = location.state || {};
    
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [orderDetails, setOrderDetails] = useState<ORDER_HISTORY_RESPONSE | null>(null);

    useEffect(() => {
        document.title = "ویدوک | جزئیات سفارش";

        setIsLoading(true);
        backEnd.get(`orders/items?order__id=${ orderId }`).then(( result ) => {
            setOrderDetails(result.data);
            setIsLoading(false);
        }).catch(( error ) => {
            let errorMessage = "خطای غیرمنتظره‌ای رخ داد.";
            
            if (error.response) {
                const status = error.response.status;
            
                switch (status) {
                    case 400:
                        errorMessage = "درخواست ارسال شده نامعتبر است.";
                        break;
            
                    case 401:    
                    case 403:
                        useUserStore.getState().setUser(null);
                        localStorage.removeItem("user-storage");
            
                        errorMessage = "لطفاً ابتدا وارد حساب کاربری خود شوید یا ثبت نام کنید!";
                        navigate("/sign-in");
                        break;
            
                    case 404:
                        errorMessage = "سفارشی برای شما پیدا نشد.";
                        break;
            
                    case 429:
                        errorMessage = "تعداد درخواست‌ها زیاد است. لطفاً کمی بعد دوباره تلاش کنید.";
                        break;
            
                    case 500:
                        errorMessage = "خطایی در سرور رخ داده است. لطفاً بعداً تلاش کنید.";
                        break;
            
                    case 503:
                        errorMessage = "سرور موقتاً در دسترس نیست.";
                        break;
            
                    default:
                        errorMessage = "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
                }
            } else if (error.request) {
                errorMessage = "اتصال به سرور برقرار نشد. اینترنت خود را بررسی کنید.";
            } else {
                errorMessage = "مشکلی در ارسال درخواست به وجود آمد.";
            }
            
            setIsLoading(false);
            showMessage("error", errorMessage);
        });
    }, []);

    return (
        <>
            <Header />
            <LocationShow key={ 0 } pathName={`نمایش جزئیات بسته ${ orderId }`} />
            <HeaderTittle key={ 0 } headerTittleList={["عکس محصول", "نام محصول", "کد محصول", "رنگ", "تعداد", "قیمت", ""]} />

            {
                isLoading ? (
                    <p>در حال بارگذاری</p>
                ) : !orderDetails?.results || orderDetails.results.length === 0 ? (
                    <p>هیچ آیتمی وجود ندارد</p>
                ) : (
                    orderDetails?.results.map(( order: ORDER_HISTORY_ITEM ) => {
                        return <OrderHistoryBox
                            key={ order.product.id }
                            orderedItemPic={ order.product.thumbnail || NotImage }
                            orderedItemName={ order.product.full_name }
                            orderedItemCode={ order.product.id }
                            orderedItemColor={ order.item_color.color_code }
                            orderItemCount={ order.quantity }
                            orderedItemPrice={ formatPrice(Number(order.price) * order.quantity) }
                            orderedItemKey={ order.product.id }
                        />
                    })
                )
            }
        </>
    );
};

export default ShowOrderDetails;
